import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class UploadWizardInfoComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<any>;
    public transferDataForPaginatedTable = [];

    constructor() {}

    $onInit() {
        if (
            this.wizardCtrl.context.transferData &&
            this.wizardCtrl.context.transferData.length > 0
        ) {
            this.transferDataForPaginatedTable =
                this.convertTransferDataForPaginatedTable();
        }
    }

    public cancelAddProduct() {
        if (
            this.wizardCtrl.context.transferData &&
            this.wizardCtrl.context.transferData.length > 0
        ) {
            this.wizardCtrl.context.data =
                this.wizardCtrl.context.transferData[
                    this.wizardCtrl.context.transferData.length - 1
                ];
            this.wizardCtrl.goTo(3);
        }
    }

    public convertTransferDataForPaginatedTable(): any[] {
        let result: any[] = [];

        this.wizardCtrl.context.transferData.forEach((transferData: any) => {
            transferData.products.forEach((product: any) => {
                result.push({
                    transferData: transferData,
                    product: product
                });
            });
        });

        return result;
    }
}

angular.module('app').component('pkpProductUploadWizardInfo', {
    controller: UploadWizardInfoComponentCtrl,
    template:
        require('app/product-upload-wizard/product-upload-wizard-info.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
